import { QueryClient } from "@tanstack/react-query";

/** Shared TanStack Query client for the admin SPA. */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        staleTime: 60_000,
        refetchOnWindowFocus: false,
      },
    },
  });
}
